import i18n from '@/lib/i18n';
import { DeviceService } from '@/service/DeviceService.ts';
import { useDeviceStore } from '@/store/DeviceStore';
import { MicrophoneListener } from 'mind-sdk-web';
import { Microphone } from 'mind-sdk-web/lib/Microphone';

export class MicrophoneEventListener implements MicrophoneListener {
  constructor(readonly deviceService: DeviceService) {}

  onMicrophoneReleasedForcibly(microphone: Microphone) {
    if (microphone.getId() !== 'default') {
      console.warn(i18n.t('events.microphone.noStream'));
    }

    // Mark device as unset. Unlike `disable`, this explicitly means the user didn’t turn it off manually.
    useDeviceStore.getState().setMicrophone(null);

    // Try to reselect a default device immediately.
    // This helps:
    // - recover the device ASAP if it's still usable
    // - surface permission or device errors to the user
    this.deviceService.useDefaultMicrophone().catch((error) => {
      console.error(i18n.t('events.microphone.errorSettingDefault'), error);
    });
  }
}
